$(document).ready(function () {
  function tabSlide() {
    if (prevApply.hasClass('active')) {
      parentTab.scrollLeft(maxLeft);
    } else {
      parentTab.scrollLeft(0);
    }
  }
  let prevApply = $(document).find('#optPrevApply');
  let parentTab = $(document).find('.nav-talent-job-wrapper');
  let tabElement = $(document).find('#tabJobs');
  let tabWidth = tabElement.width();
  let parentWidth = parentTab.width();
  let windowWidth = $(window).width();
  let containerWidth = $('.container').width();
  let maxLeft = tabWidth - containerWidth;

  console.log(maxLeft);

  $(window).on('click', function () {
    if (parentWidth === windowWidth) {
      tabSlide();
    }
  });
});
